import template from './tnt_control.html';
import controller from './tnt_control.controller';
import './tnt_control.scss';

let tntControlComponent = {
  restrict: 'E',
  bindings: {
  },
  template,
  controller
};

export default tntControlComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/tnt_control.component.js